import React, { useCallback, useContext, useEffect, useState } from 'react'
import PricingStructure from './PricingStructure';
import Products from './Products';
import './AdminPricingSettings.scss'
import SelectedPricingStructure from './SelectedPricingStructure';
import SelectPricingOption from './SelectPricingOption';
import PricingTabs from './PricingTabs/PricingTabs';
import {ReactComponent as Close} from "../../../images/closeIcon.svg"
import { ReactComponent as Lut } from "../../../images/LutLogo.svg";
import { ReactComponent as TSYS } from "../../../images/TsysLogo.svg";
import { ReactComponent as FirstData } from "../../../images/FirstDataLogo.svg";
import {ReactComponent as GreenTick} from "../../../images/greenTick.svg"
import { BreadCrumb, SelectedStructure } from '../../../models/AdminSettingsM/AdminPricingSettingsModel';
import Service from '../../../services';
import { BankUserContext } from '../../../bankUserContext';
import { IOrgProductModel } from '../../../models/SharedModel';
import { catchError } from '../../../utils/Utils';

interface AdminProps{
  tabName?:string | null;
}


const AdminPricingSettings = (props: AdminProps) => {
  const [component, setComponent] = useState('Products')
  const [breadCrumbs, setBreadCrumbs] = useState<BreadCrumb[]>([{name:"Admin Pricing Settings",heirarchy:0,element:undefined}])
  const [pricingTab,setPricingTab] = useState(false)
  const [selectedpricingStructure,setSelectedPrcingStructure] = useState<SelectedStructure>()
  const [msg,setMsg] = useState('')
  const [disable,setDisable] = useState<boolean>(false)

  
  const pricingData=[
    {
      id:0,
      name:'Lut Pricing Structure',
      image:<Lut/>,
    },
    {
      id:1,
      name:'TSYS Pricing Structure',
      image:<TSYS/>
    },
    {
      id:2,
      name:'First Data Pricing Structure',
      image:<FirstData/>
    },
  ]

  useEffect(()=>{    
    setBreadCrumbs([{name:"Admin Pricing Settings",heirarchy:0}])
    setComponent("Products")
  },[JSON.stringify(props)])

  const breadCrumbsHandler = (selectedPricingStructure:SelectedStructure,editComponent?:boolean) =>{
    if(editComponent) {
      setDisable(false)
    }
    setSelectedPrcingStructure(selectedPricingStructure)
    setPricingTab(false)
    setBreadCrumbs((prev:BreadCrumb[])=>{ 
    const addingValue = editComponent ? 2 : 1
    const lastIndex = prev?.[prev?.length-1].heirarchy+addingValue || 0; 
    return [...prev,{name:data[lastIndex].name,heirarchy:data[lastIndex].heirarchy}]})
  } 



  const message = (messageType:string) =>{
    switch (messageType){
      case "edit":
        setMsg("edited");
        break;
      case "save":
        setMsg("saved")
        break;
      case "duplicate":
        setMsg("duplicated")
        break;
      case "delete":
        setMsg("deleted")
        break;
      default:
        setMsg('')
    }
  }

  const cancelButton = () =>{
    setBreadCrumbs((prev:BreadCrumb[])=>{
      if (prev.length === 0) return prev;
      return prev.slice(0, -1);
    })
    setPricingTab(true)
  }

  const backButton = () => {
    setBreadCrumbs([...breadCrumbs].slice(0, 1))
    setComponent('Products')
  }

  const nextButton = () => {
    setDisable(true)
    setBreadCrumbs((prev:BreadCrumb[])=>{
      const lastIndex = prev?.[prev?.length-1].heirarchy+1 || 0; 
    return [...prev.slice(0, -1),{name:data[lastIndex].name,heirarchy:data[lastIndex].heirarchy}]})
  }

  const data:BreadCrumb[] = [
    {
      heirarchy: 0,
      name: 'Admin Pricing Settings',
      element: <Products productsHandler={breadCrumbsHandler}/>
    },
  
    {
      heirarchy: 1,
      name: 'Selected Pricing',
      element: <SelectedPricingStructure message = {message} selectedpricingStructure = {selectedpricingStructure} selectedPricingHandler={breadCrumbsHandler} editHandler={breadCrumbsHandler} setTab={pricingTab}/>
    },
      {
      heirarchy: 2,
      name: 'Payments',
      element: <PricingStructure pricingStructureHandler={breadCrumbsHandler} backButton={backButton} />
    },
    {
      heirarchy: 3,
      name: 'New Template',
      element: <SelectPricingOption next={nextButton} cancelButton={cancelButton}/>
    }, 
    {
      heirarchy: 4,
      name: 'Edit Template',
      element: <PricingTabs cancelButton={cancelButton} message = {message} disable={disable}/>
    }
  ]

  const onClickBreadCrumb = (index: number) => {
    setBreadCrumbs([...breadCrumbs].slice(0, index + 1))
  }

  const renderComponent= useCallback(()=>{
    const lastIndex = breadCrumbs?.[breadCrumbs?.length-1]||{name:"Admin Pricing Settings",heirarchy:0}
    return data?.find((m:BreadCrumb)=>m.name===lastIndex.name)?.element || <></>
  },
[JSON.stringify(breadCrumbs)])

  return (
    <>
      <div className="breadCrumbs">
        {breadCrumbs.map((m: any, index: number) => {
          const isLast = index === breadCrumbs.length - 1;
          return (
            <React.Fragment key={index}>
              {index !== 0 && <span className="greaterSymbol">{'>'}</span>}
              <p onClick={() => onClickBreadCrumb(index)} className={`name ${isLast ? 'lastElement' : ''}`}>{m.name}</p>
            </React.Fragment>
          )
        })}
      </div>
      <div className="selectedPricingImage">
        {msg && msg.length > 0  && breadCrumbs&& breadCrumbs.length === 3 ? <div className="message">
          <GreenTick className="greenTick"/>
        <span>Template Name Here successfully {msg} </span>
        <Close onClick ={()=>setMsg('')} className="crossIcon"/>
        </div> : 
        breadCrumbs&& breadCrumbs.length === 3 && 
        <>
        {pricingData.map((m)=>{if(m.name ===  selectedpricingStructure?.name){
          return(
            <>{m.image}</>
          )
        }})}</>    
        }
        {}
      </div>
      {renderComponent()}
    </>
  )
}

export default AdminPricingSettings